import { render, staticRenderFns } from "./ContentConfigurator.vue?vue&type=template&id=99645738&"
import script from "./ContentConfigurator.vue?vue&type=script&lang=js&"
export * from "./ContentConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports